import { Button } from 'tuui';
import { GTM_EVENTS } from 'modules/taboola-common-frontend-modules/gtmTracker';
import { FormattedMessage } from 'modules/taboola-common-frontend-modules/i18n';

export const CreateLibraryCreativeButton = () => {
    return (
        <div
            data-metrics-event-name={GTM_EVENTS.USABILITY}
            data-metrics-component="Create Rules Button"
            data-automation="Create LibraryC Button"
        >
            <Button onClick={() => console.log('coral')}>
                <FormattedMessage id="creative.library.new.button" defaultMessage="New" />
            </Button>
        </div>
    );
};
